import Vue from 'vue'
import Router from 'vue-router'
import ManualProcessingView from '../views/ManualProcessingView.vue'
import ReportsView from '../views/ReportsView.vue'
import DocumentationView from '../views/DocumentationView.vue'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'reports',
			component: ReportsView
		},
		{
			path: '/manual',
			name: 'manualprocessing',
			component: ManualProcessingView
		},
		{
			path: '/doc',
			name: 'doc',
			component: DocumentationView
		}
	]
})
